import * as React from 'react';
import { TableFavouriteModelComponent } from './table-favourite-model-component';
import { FavouriteLayoutComponentProps } from '../types';
import { FavouriteRow } from './types';
import { mapToRows, shouldDisplayTotal } from './view-model';
import { RenderCell, renderAggregateCell, renderTableHeader, renderTableFooter } from './table';
import { tableConfig } from './config';
import { ScrollContainer } from 'ui/scroll-container';

import styles from './table-view-favourite.scss';

export class TableViewFavourite extends React.PureComponent<FavouriteLayoutComponentProps> {
  private model: TableFavouriteModelComponent;

  constructor(props: FavouriteLayoutComponentProps) {
    super(props);
    this.model = new TableFavouriteModelComponent(
      props.layoutAttributes, props.intl, props.translation, undefined, this.props.drillDown, this.props.caseview);

      if (props.favouriteDataModel) {
      this.model.receiveData(props.favouriteDataModel);
    }
  }

  public componentDidUpdate(prevProps: FavouriteLayoutComponentProps) {
    if (this.props.layoutAttributes) {
      if (!this.props.fetchingDataModel && prevProps.favouriteDataModel !== this.props.favouriteDataModel) {
        this.model.receiveData(this.props.favouriteDataModel);
        this.forceUpdate();
      }
    }
  }

  public render() {

    if (!this.model || !this.model.dataModel || !this.model.dataModel.rows || this.model.dataModel.rows.length === 0) {
      return <div className={styles.spinLoader} />;
    }
    const { dataModel: { columns, rows, report }, dataAdapter } = this.model;
    const { hideAggrColumns, hideHeader, hideTotals, compactView, suppressRepeatingRows } = tableConfig(this.props.layoutAttributes);

    const data = mapToRows(dataAdapter, this.model, rows, columns, compactView);
    return <ScrollContainer height={this.props.height}>
        <table className={styles.result}>
          {!hideHeader && renderTableHeader(data[0], hideAggrColumns, compactView)}
          <tbody>
            {data.map((r, i) => this.renderTableBody(r, i > 0 && data[i - 1], i, suppressRepeatingRows, hideAggrColumns))}
            {!hideAggrColumns && !hideTotals && shouldDisplayTotal(dataAdapter, columns, report)
              && renderTableFooter(this.model, data[0], hideAggrColumns, this.footerClickHandler)}
          </tbody>
        </table>
    </ScrollContainer>;
  }

  private renderTableBody = (row: FavouriteRow, previousRow: FavouriteRow, index: number,
    suppressRepeatingRows: boolean, hideAggrColumns: boolean) => {
    return <tr key={index}>
      {row.selectionValues.map((c, i) => {
        const suppressRepeating = suppressRepeatingRows && !!previousRow &&
          previousRow.selectionValues
            .filter((pc, pi) => pi <= i)
            .every((pc, pi) => pc.value === row.selectionValues[pi].value);
        return suppressRepeating ? <td key={i} />
          : <RenderCell key={i} cell={c} index={i}/>;
      })}
      {!!row.aggregateValue && renderAggregateCell(row.aggregateValue)}
      {!hideAggrColumns && !!row.subValue && <RenderCell cell={row.subValue}/>}
      {!hideAggrColumns && !!row.rollingAvarage && renderAggregateCell(row.rollingAvarage)}
      {!hideAggrColumns && !!row.target && renderAggregateCell(row.target)}
    </tr>;
  };

  private footerClickHandler = () => {

    const { drillDownHandler } = this.model;
    drillDownHandler && drillDownHandler.toCaseListingWithAllCases();
  };
}
